export const projectMockUps = [
	{
		id: 1,
		name: 'Creation Foundation',
		description: 'Develop the foundation for our creation engine',
		manager: 'Walt Cosani',
		assignedTo: 'Ignacio Truffa',
		status: 'Enabled',
		createdAt: '19/06/2021 10:30 am'
	},
	{
		id: 2,
		name: 'Landing Page',
		description: 'Some Description',
		manager: 'Walt Cosani',
		assignedTo: 'Ignacio Truffa',
		status: 'Enabled',
		createdAt: '09/09/2020 10:30 am',
	},
	{
		id: 3,
		name: 'E-Commerce Shop',
		description: 'Simplified shop for local enterpreneurs',
		manager: 'Walt Cosani',
		assignedTo: 'Ignacio Truffa',
		status: 'Enabled',
		createdAt: '02/04/2020 14:30 am',
	},
	{
		id: 4,
		name: 'CRM Linkroom',
		description: 'Meeting links CRM',
		manager: 'Walt Cosani',
		assignedTo: 'Ignacio Truffa',
		status: 'Enabled',
		createdAt: '20/04/2021 05:10 pm',
	}

];

export default projectMockUps;